import { getSupabaseClient } from '../../lib/supabase';

function equivalentBarcodeValues(value: string): string[] {
  const codes = [value];
  if (/^\d{12}$/.test(value)) codes.push(`0${value}`);
  if (/^0\d{12}$/.test(value)) codes.push(value.slice(1));
  return codes;
}

export async function findProductIdByEan(ean: string): Promise<string | null> {
  const cleaned = ean.trim();
  const { data, error } = await getSupabaseClient()
    .from('products')
    .select('id, ean')
    .in('ean', equivalentBarcodeValues(cleaned))
    .eq('is_active', true)
    .limit(2);
  if (error) throw new Error('Izdelka ni bilo mogoče poiskati.');
  return (
    data?.find((product) => product.ean === cleaned)?.id ??
    data?.[0]?.id ??
    null
  );
}
